/**
 * Created by Simon Zhao on 7/20/2021.
 * Description:
 * A utility providing some common functions shared between grids.
 * ------ maintenance history ------
 */
export class GridUtility {
    static cellStyleFunc = (params) => {
        const styles = {
            'white-space': 'nowrap',
            'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'display': 'block',
            'border': 'none',
        };
        if (params.data && !params.data.active) {
            return Object.assign(styles, { 'color': '#8C8C8C' });
        } else {
            return styles;
        }
    };

    static stringComparerFunc = (v1, v2) => {
        let intv1, intv2 = 1;
        if ('string' === typeof v1 && v1.trim() !== '') {
            intv1 = v1.split('').reduce((acc, cur, ind) => acc + cur.charCodeAt(0) / Math.pow(128, ind), 0);
        }
        if ('string' === typeof v2 && v2.trim() !== '') {
            intv2 = v2.split('').reduce((acc, cur, ind) => acc + cur.charCodeAt(0) / Math.pow(128, ind), 0);
        }
        return intv1 - intv2;
    };

    static customColumnSortComparator(nodeA, nodeB, column): any {
        const rowGroupIndex = column.rowGroupIndex;
        const getParentNodeByGroupIndex = (node) => {
            let temp = node;
            while (temp && temp.level !== rowGroupIndex) {
                temp = temp.parent;
            }
            return temp;
        };
        // add nodeA, because click column menu will error
        const comparatorNodeA = getParentNodeByGroupIndex(nodeA);
        const comparatorNodeB = getParentNodeByGroupIndex(nodeB);
        if (comparatorNodeA && comparatorNodeA.level === rowGroupIndex && comparatorNodeB.level === rowGroupIndex) {
            const valueA = comparatorNodeA.key;
            const valueB = comparatorNodeB.key;
            if ((valueA === undefined && valueB === undefined) || (valueA === null && valueB === null)) {
                return 0;
            }
            if (valueA === undefined || valueA === null) {
                return -1;
            }
            if (valueB === undefined || valueB === null) {
                return 1;
            }
            if (typeof valueA === 'string' && typeof valueB === 'string') {
                const alow = valueA.toLowerCase();
                const blow = valueB.toLowerCase();
                return alow === blow ? 0 : (alow > blow ? 1 : -1);
            } else if (!valueA && valueB && typeof valueB === 'string') {
                return -1;
            } else if (!valueB && valueA && typeof valueA === 'string') {
                return 1;
            } else if (typeof valueA === 'number' && typeof valueB === 'number') {
                return valueA - valueB;
            } else if ((!valueA && typeof valueB === 'number') ||
                (!valueB && typeof valueA === 'number')) {
                return valueA.localeCompare(valueB);
            } else if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
                const alow = valueA.toString().toLowerCase();
                const blow = valueB.toString().toLowerCase();
                return alow === blow ? 0 : (alow > blow ? 1 : -1);
            } else if ((!valueA && typeof valueA !== 'boolean' && typeof valueB === 'boolean') ||
                (!valueB && typeof valueB !== 'boolean' && typeof valueA === 'boolean')) {
                return valueA.localeCompare(valueB);
            }
            return valueA - valueB;
        }
        return 0;
    }
}

export const DEFAULT_PAGE_SIZE = 9999;
